import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BsClockHistory, BsCalendar2Check, BsStopwatch } from "react-icons/bs";
import OverviewTab from "./OverviewTab";
import LeaveTab from "./LeaveTab";
import PermissionTab from "./PermissionTab";
import LocationShareCard from "./LocationShareCard";

const TABS = [
    { key: "overview", name: "Today", icon: <BsClockHistory />, Component: OverviewTab },
    { key: "leave", name: "Leave", icon: <BsCalendar2Check />, Component: LeaveTab },
    { key: "permission", name: "Permission", icon: <BsStopwatch />, Component: PermissionTab },
];

const Attendance = () => {
    // The tab lives in the URL (?tab=permission) with its list's page and filters, so Back returns to it.
    const location = useLocation();
    const navigate = useNavigate();
    const wanted = new URLSearchParams(location.search).get("tab");
    const activeTab = TABS.some((tab) => tab.key === wanted) ? wanted : TABS[0].key;
    // A new tab starts on its first page with no filters.
    const setActiveTab = (key) => {
        if (key === activeTab) return;
        navigate({ pathname: location.pathname.replace(/\/page\/\d+\/?$/, ""), search: key === TABS[0].key ? "" : `?tab=${key}` });
    };
    const ActiveComponent = TABS.find((tab) => tab.key === activeTab)?.Component || TABS[0].Component;

    return (
        <div className="attendance-page">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                <div>
                    <h4 className="fw-semibold mb-1">My Attendance</h4>
                    <p className="text-muted mb-0">Mark your shift, take breaks, and request time off.</p>
                </div>
            </div>

            <LocationShareCard />

            <div className="att-tabs" role="tablist">
                {TABS.map((tab) => (
                    <button
                        key={tab.key}
                        type="button"
                        role="tab"
                        aria-selected={activeTab === tab.key}
                        className={`att-tab-btn ${activeTab === tab.key ? "active" : ""}`}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        <span className="att-tab-icon">{tab.icon}</span>
                        {tab.name}
                    </button>
                ))}
            </div>

            <ActiveComponent />
        </div>
    );
};

export default Attendance;
